import React, { useState, useRef, useEffect } from "react";
import icons from "../../icons";
import icon from "../../../helpers/useIcon";
import { useTheme } from "@mui/material/styles";
import { base64ToImageUrl, isBase64Image } from "../../../helpers/imageHelper";
import ButtonCustom from "../../CustomButton";
import { Box } from "@mui/material";

const CategoriasTabs = ({
  grupoArticulo = [],
  selectedGrupo,
  onGrupoSelect,
  innerWidth = false,
  dynamicColor,
}) => {
  const theme = useTheme();

  const containerRef = useRef(null);

  const categoriasItems = grupoArticulo.map(ga => {
    let iconToUse;
    let isImageIcon = false;

    if (ga.imagen && isBase64Image(ga.imagen)) {
      // Usar imagen base64
      iconToUse = base64ToImageUrl(ga.imagen);
      isImageIcon = true;
    } else {
      // Usar sistema anterior de iconos
      iconToUse = icons[icon(ga.descripcion)];
      isImageIcon = false;
    }

    return {
      id: ga.idCategoriaTotem,
      label: ga.descripcion,
      customComponent: ButtonCustom,
      componentProps: {
        description: ga.descripcion,
        icon: iconToUse,
        isImageIcon: isImageIcon,
        sizeIcon: ga.descripcion === "HELADERA" ? 45 : 55,
        fontSize: 12,
      },
      onClick: () => onGrupoSelect && onGrupoSelect(ga.idCategoriaTotem),
    };
  });

  const renderCustomButton = (item, idx) => {
    const isActive = selectedGrupo === item.id;

    return (
      <Box
        key={idx}
        sx={{
          flex: "0 0 auto",
          display: "flex",
          mb: 2,
          justifyContent: "center",
        }}
      >
        <item.customComponent
          {...item.componentProps}
          active={isActive}
          dynamicColor={theme.bandera.colorSecundario}
          sx={{
            width: 140,
            height: 140,
            maxHeight: 140,
            borderRadius: 8,
            backgroundColor: isActive ? theme.bandera.colorSecundario : "#fff",
            color: isActive ? "#fff" : "#000",
            ...item.componentProps.sx,
          }}
          onClick={(event) => handleItemSelect(item, event)}
          onTouchStart={(event) => handleItemSelect(item, event)}
        />
      </Box>
    );
  };

  const handleItemSelect = (item, event) => {
    if (event) {
      event.stopPropagation();
    }
    
    console.log("Item seleccionado:", item);
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <Box
      ref={containerRef}
      display="flex"
      alignItems="center"
      width="100%"
      sx={{ flexShrink: 0 }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {categoriasItems.map((item, idx) => {
          return renderCustomButton(item, idx);
        })}
      </Box>
    </Box>
  );
};

export default CategoriasTabs;
